import {ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {EMPTY, Observable} from 'rxjs';
import {catchError, take} from 'rxjs/operators';
import {_Service} from '../service/_service';
import {HasId} from '../../model';

// tslint:disable:class-name
export class _DetailResolver<T extends HasId<I>, I> implements Resolve<T> {
  constructor(private router: Router, private toastr: ToastrService, private service: _Service<T, I>,
              private path: string) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<T> {
    const id = route.params[`id`];
    return this.service.detail(id).pipe(
      take(1),
      catchError(err => {
        this.toastr.error(`${err.message}<br/>id=${id}`, 'Fehler beim Laden!',
          {disableTimeOut: true});
        this.router.navigate([this.path]).then();
        return EMPTY;
      })
    );
  }
}
